export default __webpack_public_path__ + "static/media/results-household-habits.06dc3309.jpg";